import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { surviveTreeShaking } from '@df/ng/survive-tree-shaking';
import { CatalogCommonModule } from '../catalog/catalog-common.module';
import { RelatedProductsComponent } from '../catalog/product/related-products/related-products.component';
import { SharedModule } from '../shared.module';
import { CmsAccordionComponent } from './accordion/cms-accordion.component';
import { CmsButtonComponent } from './button/cms-button.component';
import { CmsCategoryCarouselComponent } from './category-carousel/cms-category-carousel.component';
import { CmsCategoryLandingPageHeaderComponent } from './category-landing-page-header/cms-category-landing-page-header.component';
import { CmsCustomFormComponent } from './customform/cms-customform.component';
import { CmsEditorialComponent } from './editorial/cms-editorial.component';
import { CmsFaqComponent } from './faq/cms-faq.component';
import { CmsFeaturedProductsComponent } from './featured-products/cms-featured-products.component';
import { CmsHeroCarouselComponent } from './hero-banner-carousel/cms-hero-banner-carousel.component';
import { CmsHeroBannerComponent } from './hero-banner/cms-hero-banner.component';
import { CmsHtmlComponent } from './html/cms-html.component';
import { CmsIframeComponent } from './iframe/cms-iframe.component';
import { CmsImageQuoteComponent } from './image-quote/cms-image-quote.component';
import { CmsImageComponent } from './image/cms-image.component';
import { CmsIndexedTextComponent } from './indexed-text/cms-indexed-text.component';
import { CmsNewsletterModalComponent } from './newsletter-modal/cms-newsletter-modal.component';
import { CmsNewsletterComponent } from './newsletter/cms-newsletter.component';
import { CmsQuickLinksComponent } from './quick-links/cms-quick-links.component';
import { CmsRelatedProductsComponent } from './related-products/cms-related-products.component';
import { CmsSectionComponent } from './section/cms-section.component';
import { CmsSeoContentComponent } from './seo-content/cms-seo-content.component';
import { CmsServiceMessagesComponent } from './service-messages/cms-service-messages.component';
import { CmsTextComponent } from './text/cms-text.component';
import { CmsUGCComponent } from './ugc/cms-ugc.component';
import { UGCModalComponent } from './ugc/tray/ugc-modal.component';
import { CmsVideoComponent } from './video/cms-video.component';

const components = [
    CmsAccordionComponent,
    CmsButtonComponent,
    CmsCustomFormComponent,
    CmsCategoryCarouselComponent,
    CmsCategoryLandingPageHeaderComponent,
    CmsEditorialComponent,
    CmsHtmlComponent,
    CmsSectionComponent,
    CmsIndexedTextComponent,
    CmsImageComponent,
    CmsNewsletterComponent,
    CmsQuickLinksComponent,
    CmsFaqComponent,
    CmsRelatedProductsComponent,
    CmsTextComponent,
    CmsHeroBannerComponent,
    CmsFeaturedProductsComponent,
    CmsSeoContentComponent,
    CmsServiceMessagesComponent,
    CmsUGCComponent,
    CmsVideoComponent,
    CmsIframeComponent,
    CmsImageQuoteComponent,
    CmsNewsletterModalComponent,
    CmsHeroCarouselComponent,
    UGCModalComponent,
    RelatedProductsComponent
];

@NgModule({
    imports: [SharedModule, CatalogCommonModule, CommonModule],
    declarations: [...components],
    exports: [...components]
})
export class CmsModule {
    constructor() {
        surviveTreeShaking(components);
    }
}
